// 导入请求数据的 request 模块
import request from '@/utils/request'

// 根据省份、专业、年级查询资料信息
export const SelectDataDownload = (province, major, grade, currentPage, pageSize) => {
  return request.get('/datadownload/select', {
    params: {
      province: province,
      major: major,
      grade: grade,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据学校名称查询资料信息
export const SelectDataDownloadSchoolName = (schoolname, currentPage, pageSize) => {
  return request.get('/datadownload/select/schoolname', {
    params: {
      schoolname: schoolname,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据资料名称查询资料信息
export const SelectDataDownloadDataName = (filename, currentPage, pageSize) => {
  return request.get('/datadownload/select/dataname', {
    params: {
      filename: filename,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据省份、专业、年级查询资料信息
export const selectDataDownload = (province, major, grade, currentPage, pageSize) => {
  return request.get('/datadownload/select', {
    params: {
      province: province,
      major: major,
      grade: grade,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据文件id下载文件
export const filesDownloadById = (id) => {
  return request.post('/datadownload/id', id, {
    params: {
      id
    },
    responseType: 'blob'
  })
}
